"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _linkContainer = require("../link-container");

var _SvgInPlusFat = require("../svg/interface/SvgInPlusFat");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["onChange", "classes", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c1855094b{display:flex;align-items:center;height:1.75rem}.c014fdbf5{display:none}.c3b8bb0bc{display:block}");
var styles = {
  root: 'c1855094b',
  input: 'c014fdbf5',
  button: 'c3b8bb0bc'
};

var FileInput = function FileInput(props) {
  var onChange = props.onChange,
      classes = props.classes,
      children = props.children,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var inputEl = (0, _react.useRef)(null);
  var onClickHandler = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    inputEl.current.click();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    ref: inputEl,
    type: "file",
    className: cn.input,
    onChange: onChange
  }, rest)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.button
  }, /*#__PURE__*/_react.default.createElement(_linkContainer.LinkContainer, {
    hasIcon: true,
    iconSize: "small",
    size: "middle"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "/",
    onClick: onClickHandler
  }, /*#__PURE__*/_react.default.createElement(_SvgInPlusFat.SvgInPlusFat, null), /*#__PURE__*/_react.default.createElement("span", null, children)))));
};

exports.FileInput = FileInput;
FileInput.propTypes = {
  /* component logic props */
  onChange: _propTypes.func.isRequired,
  children: _propTypes.node,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
FileInput.defaultProps = {
  classes: {},
  children: 'Add file'
};